import React from "react";
import Routing from "./Routing";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../src/Redux/Store";
import { ConfigCatProvider, createConsoleLogger, LogLevel, PollingMode } from "configcat-react";

import "./index.scss";
import "./font.scss";
import { RootComponentProps } from "./root-component.props";

const RootComponent = ({
  breadcrumbObservable,
  tokenExpiryMessageSubjectObservable,
  tokenSubject,
  schedulerAssessmentSubject,
  schedulerAssessmentObservable,
  ilpsubject,
  ilpObservable,
  MyPathLevelSubject,
  MyPathBreadcrumbsSubjectObservable,
  assignmentBuilderBreadcrumbSubject,
  assignmentBuilderBreadcrumbObservable,
  assignmentBuilderCustomPropsSubject,
  assignmentBuilderCustomPropsSubjectObservable,
  BenchmarkGrowthReportBreadcrumbSubject,
  BenchmarkGrowthReportBreadcrumbSubjectObservable,
  BenchmarkGrowthReportBackSubject,
  BenchmarkGrowthReportBackObservable,
  standardsProficiencyReportBreadcrumbsObservable,
  ActivityIndicatorSubject,
  ActivityIndicatorObservable,
  mpngClassSummarySubject,
  mpngClassSummaryObservable,
  mpngStudentIlpSubject,
  mpngStudentIlpObservable,
  dsdsReportSubject,
  studentProgressSubject,
  subjectMFE,
  timeZoneSubject,
  userBehaviorSubject,
  organizationBehaviorSubject,
  breadcrumbSubject,
  tokenExpiryMessageSubject,
  observableMFE
}: RootComponentProps) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigCatProvider
          sdkKey={`configcat-proxy/mypath-frontends-${window.APP_ENV.app_env}`}
          pollingMode={PollingMode.AutoPoll}
          options={{
            pollIntervalSeconds: 300, // 5mins
            baseUrl: window.APP_ENV.configcat_proxy_url,
            logger: createConsoleLogger(LogLevel.Info)
          }}
        >
          <Routing
            breadcrumbObservable={breadcrumbObservable}
            tokenExpiryMessageSubjectObservable={tokenExpiryMessageSubjectObservable}
            tokenSubject={tokenSubject}
            schedulerAssessmentSubject={schedulerAssessmentSubject}
            schedulerAssessmentObservable={schedulerAssessmentObservable}
            ilpsubject={ilpsubject}
            ilpObservable={ilpObservable}
            MyPathLevelSubject={MyPathLevelSubject}
            MyPathBreadcrumbsSubjectObservable={MyPathBreadcrumbsSubjectObservable}
            assignmentBuilderBreadcrumbSubject={assignmentBuilderBreadcrumbSubject}
            assignmentBuilderBreadcrumbObservable={assignmentBuilderBreadcrumbObservable}
            assignmentBuilderCustomPropsSubject={assignmentBuilderCustomPropsSubject}
            assignmentBuilderCustomPropsSubjectObservable={assignmentBuilderCustomPropsSubjectObservable}
            BenchmarkGrowthReportBreadcrumbSubjectObservable={BenchmarkGrowthReportBreadcrumbSubjectObservable}
            BenchmarkGrowthReportBreadcrumbSubject={BenchmarkGrowthReportBreadcrumbSubject}
            BenchmarkGrowthReportBackSubject={BenchmarkGrowthReportBackSubject}
            BenchmarkGrowthReportBackObservable={BenchmarkGrowthReportBackObservable}
            standardsProficiencyReportBreadcrumbsObservable={standardsProficiencyReportBreadcrumbsObservable}
            ActivityIndicatorSubject={ActivityIndicatorSubject}
            ActivityIndicatorObservable={ActivityIndicatorObservable}
            mpngClassSummarySubject={mpngClassSummarySubject}
            mpngClassSummaryObservable={mpngClassSummaryObservable}
            mpngStudentIlpSubject={mpngStudentIlpSubject}
            mpngStudentIlpObservable={mpngStudentIlpObservable}
            dsdsReportSubject={dsdsReportSubject}
            studentProgressSubject={studentProgressSubject}
            subjectMFE={subjectMFE}
            timeZoneSubject={timeZoneSubject}
            userBehaviorSubject={userBehaviorSubject}
            organizationBehaviorSubject={organizationBehaviorSubject}
            breadcrumbSubject={breadcrumbSubject}
            tokenExpiryMessageSubject={tokenExpiryMessageSubject}
            observableMFE={observableMFE}
          />
        </ConfigCatProvider>
      </PersistGate>
    </Provider>
  );
};

export default RootComponent;
